/**
 * Texts for Library page
 */
export const libraryPageText = {
    title: 'CamAPS Liberty - CamAPS FX',
    titleMeta: 'CamAPS Liberty - CamAPS FX',
    descriptionMeta: 'Tilgang til ressurser og støttemateriell for CamAPS FX og CamAPS Liberty®.',
    keywords: 'camaps bibliotek, camaps fx, camaps liberty, støtteressurser, diabeteshåndtering',
    localeMeta: 'nb_no',

    bannerTitle: 'Støtte utover tallene',
    bannerSubtitle: 'med CamAPS Liberty<sup>®</sup>',
    bannerDescription: 'Når aktivert, trenger brukere ikke telle karbohydrater og levere en for-måltids insulinbolus.',
    bannerCompatibility: 'Kompatibel med Android og iOS',
    
    announcementText: 'Nå tilgjengelig i myLoop',
    announcementDisclaimer: '',

    introTitle: 'Den første fullt lukket sløyfe-funksjon. Når du trenger den.',
    introDescription: 'Når den er aktivert, trenger brukere ikke å telle karbohydrater og gi en for-måltid insulinbolus.',
    introSubtext: 'Tilgjengelig på Android- og Apple-operativsystemer',

    howItWorksTitle: 'Hvordan fungerer det?',
    howItWorksDescription: 'Drevet av en mer proaktiv versjon av CamAPS-algoritmen. CamAPS Liberty forutser og responderer på glukoseendringer samtidig som etablerte sikkerhetsgrenser opprettholdes.',
    
    step1Title: 'STEG 1',
    step1Description: 'Gå fra hjemskjermen din til innstillingsmenyen.',
    step2Title: 'STEG 2',
    step2Description: 'Rull ned til bunnen og trykk på bryteren for å aktivere.',
    step3Title: 'STEG 3',
    step3Description: 'Ved første bruk må du se vår forklarende video om CamAPS Liberty.',
    step4Title: 'STEG 4',
    step4Description: 'Bekreft at du ikke er under 13 år eller gravid.',
    step5Title: 'STEG 5',
    step5Description: 'Trykk på bryteren igjen for å aktivere.',
    step6Title: 'STEG 6',
    step6Description: "Alt er klart. CamAPS Liberty-fanen vises på hjemskjermen<sup>†</sup>.",
    step6Footnote: "<sup>†</sup> Fungerer bare når \"Auto mode\" er på",

    eligibilityTitle: 'Hvem kan bruke CamAPS Liberty?',
    eligibilityCriterion1: 'Eksisterende brukere med type 1 diabetes',
    eligibilityCriterion2: '13 år og eldre',
    eligibilityCriterion3: 'Gravid',
    parentsCarersTitle: 'Hva med foreldre og omsorgspersoner?',
    parentsCarersBlockTitle: 'Funksjonen "Sperrefunksjon":',
    parentsCarersBlockDescription: 'For å forhindre utilsiktet bruk',
    parentsCarersRemoteTitle: 'Fjernovervåking:',
    parentsCarersRemoteDescription: 'Companion, Glooko® og CamAPS 2-ukers PDF-rapporter',

    imageOverlayText: 'Designet for å fungere sammen med din nåværende diabeteshåndteringsplan; ikke for å erstatte den.',
    
    usingTitle: 'Bruke CamAPS Liberty',
    
    treatmentPlanText: 'CamAPS Liberty er utviklet for å fjerne behovet for rutinemessige måltidsboluser. Funksjonen erstatter ikke de andre delene av brukerens diabetesbehandlingsplan, inkludert regelmessig oppfølging med diabetesteamet.',
    
    usingLibertyTitle: 'Se og lær om CamAPS Liberty',
    usingLibertyDescription: 'Utforsk videoer for å lære mer om CamAPS Liberty og hvordan du kommer i gang.',
    // latestVideoLabel removed
    moreVideosLabel: 'Flere videoer',
    factsheetDownloadText: 'CamAPS Liberty-faktablad (pdf)',
    factsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_no.pdf',
    usingLibertyFeaturedVideo: {
        youtubeUrl: 'https://youtu.be/px9QSOhy544',
        title: 'CamAPS Liberty: Kom i gang',
        description: 'Candice Ward forklarer hvordan du setter opp og begynner å bruke CamAPS Liberty.',
        duration: '31:50',
        date: '15 Sep 2026',
    },
    usingLibertyMoreVideos: [
        {
            youtubeUrl: 'https://youtu.be/XPgf5D_tsc4',
            title: 'Praktiske Tips: CamAPS Liberty',
            duration: '01:53',
        },
        {
            youtubeUrl: 'https://youtu.be/K7_j-Sk5Fas',
            title: 'Introduksjon til CamAPS Liberty',
            duration: '14:42',
        },
        {
            youtubeUrl: 'https://youtu.be/0dp5A8z_SEk',
            title: 'Den fully closed-loop-følelsen',
            duration: '04:22',
        },
        {
            youtubeUrl: 'https://youtu.be/CJWx6wQz9jM',
            title: 'CamAPS Liberty-funksjonen',
            duration: '03:18',
        }
    ],
    
    whatHappensNextTitle: 'Hva skjer videre?',
    whatHappensNextText: 'Vi vil kjøre en pilot innenfor et enkelt marked i de kommende månedene. Hold deg oppdatert for flere detaljer.',
};

